import { render, staticRenderFns } from "./batchConfigLabelModal.vue?vue&type=template&id=36ae7954&scoped=true"
import script from "./batchConfigLabelModal.vue?vue&type=script&lang=js"
export * from "./batchConfigLabelModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae7954",
  null
  
)

export default component.exports